import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initializeFortAwesome } from './fortAwesomeLoader'

initializeFortAwesome()
const container = document.getElementById('app-root') as HTMLElement
const root = createRoot(container)
root.render(<App />)
